import React from "react";
import { Alert, Box, Chip, Stack } from "@mui/material";
import { getPricingTier, getNextTierWarning } from "./pricing";

interface PricingBadgeProps {
  memberCount: number;
}

const PricingBadge: React.FC<PricingBadgeProps> = ({ memberCount }) => {
  const tier = getPricingTier(memberCount);
  const warning = getNextTierWarning(memberCount);

  return (
    <Stack spacing={0.75} mt={0.5}>
      <Box>
        <Chip
          label={`${tier.label} plan — ${tier.price}`}
          color={tier.color}
          size="small"
          sx={{ fontWeight: 600, fontSize: "0.72rem" }}
        />
      </Box>
      {warning && (
        <Alert
          severity="warning"
          sx={{
            py: 0.25,
            px: 1.25,
            fontSize: "0.75rem",
            "& .MuiAlert-icon": { fontSize: "1rem" },
          }}
        >
          Adding another member will move you to the{" "}
          <strong>{warning.nextLabel} plan</strong> ({warning.nextPrice}).
        </Alert>
      )}
    </Stack>
  );
};

export default PricingBadge;
